import Image from 'semantic-ui-react/dist/commonjs/elements/Image'
export default Image
